<!-- 表单的筛选 -->
<template>
    <div>
        <el-button
                type="info"
                size="mini"
                icon="el-icon-circle-close"
                plain
                @click="DoStop()"
                class="column__tool__buttom">停用</el-button>
    </div>    
</template>

<script>
import { BaseVue } from "@/mixin/index";
import { stopApi } from '@/api/core/table/table';

export default {
  name: "DisableTableBtn",
  
  mixins: [BaseVue],
  
  props: {
    serverUrl: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      required: true
    }
  },
  
  data() {
    return {
      tagclass: "info",
      tagtext: ""
    };
  },
  
  methods: {
    init() {
      // 初始化逻辑
    },
    
    DoStop() {
      this.$confirm(`确定要停用"${this.title}"吗？`, "停用确认", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "放弃"
      }).then(() => {
        stopApi(this.serverUrl, this.id)
          .then(() => {
            this.$message({
              message: "操作成功！",
              type: "success"
            });
            this.$emit("onSuccess");
          })
          .catch(error => {
            console.log(error);
            this.$message.error("停用失败");
          });
      }).catch((error) => {
        console.log(error);
      });
    }
  },
  
  mounted() {
    this.init();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
